import { motion } from "framer-motion";
import { useLang } from "@/lib/i18n";

export const Process = () => {
  const { t } = useLang();
  return (
    <section className="split-section" id="how">
      <div>
        <div className="eyebrow">{t.process.eyebrow}</div>
        <h2>{t.process.title}</h2>
        <p className="section-intro">{t.process.intro}</p>
      </div>
      <div className="steps">
        {t.process.steps.map(([num, title, copy], i) => (
          <motion.div
            className="step"
            key={num}
            initial={{ opacity: 0, y: 22 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.55, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] }}
            data-testid={`process-step-${num}`}
          >
            <span>{num}</span>
            <div>
              <h3>{title}</h3>
              <p>{copy}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};
